export default {
  namespaced: true,
  ai_analytics_servers: {
    title: "AI Analytics Servers",
    servers: "Servers",
    server: "Server",
    server_name: "Server Name",
    service_name: "Service Name",
    host: "Host",
    limit: "Limit",
    online: "Online",
    offline: "Offline",
    id_tenant: "Tenant ID",
    devices: "Devices",
    device: "Device",
    device_name: "Device Name",
    url: "URL",
    devices_count: "Devices Count",
    number_of_devices: "Number of Devices",
    maximum_devices: "Maximum Devices",
    on_server_status: "On Server Status",
    message: "Message",
    camera: "Camera",
    created_at: "Created At",
    server_id: "Server ID",
    server_uuid: "Server UUID",
    logs: "Logs",
    id: "ID",
    uuid: "UUID",
    tenant: "Tenant",
    status_active: "Status Active",
    cameras_online: "Cameras Online",
    start_date: "Start Date",
    end_date: "End Date",
    fire_threshold: "Fire Threshold",
    smoke_threshold: "Smoke Threshold",
    use_local_confirmation: "Local Inference",
    restart_server: "Restart Server",
    uuid_not_found: "Server UUID not found",
    restarted_successfully: "Server restarted successfully",
    restart_error: "Error restarting server",
    fetch_error: "Error fetching information",
    delete_error: "Error deleting",
    update_status_error: "Error updating status",
    STREAM_ONLINE: "Stream online and operating correctly.",
    STREAM_CONNECTION_LOST: "Stream connection issues: intermittence or frame loss.",
    STREAM_HARD_DOWN: "Stream is down and could not be recovered.",
    STREAM_LOW_QUALITY: "Low stream quality: insufficient bitrate, low resolution, or packet loss.",
    AUTH_ERROR: "Invalid RTSP access token.",
  },
};
